module.exports = __webpack_public_path__ + "img/access.a24e0639.svg";